import { ChevronLeft } from '@mui/icons-material';
import { Box, ButtonBase } from '@mui/material';

import GoLogo from '@/components/GoLogo';
import Typography from '@/components/Typography';
import { spacing } from '@/constants/ui';
import { OnboardingLayout } from '@/layouts/OnboardingLayout';
import LoginComponent from '@/pages/Onboarding/LoginComponent';

import OnboardingFooter from './components/OnboardingFooter';
import OnboardingHeader from './components/OnboardingHeader';
import useOnboarding from './hooks/useOnboarding';

const Onboarding = () => {
  const { logoExpanded, resetPage, status } = useOnboarding();

  return (
    <OnboardingLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          justifyContent: {
            xs: 'center',
            md: 'flex-start'
          }
        }}
      >
        <Box
          sx={{
            display: {
              xs: 'flex',
              md: 'block'
            },
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: spacing['3']
          }}
        >
          <GoLogo open={logoExpanded} />
          {status !== 'idle' && status !== 'loading' && (
            <ButtonBase onClick={resetPage}>
              <ChevronLeft fontSize='small' />
              <Typography
                sx={{ fontSize: 16 }}
                variant='subtitle1'
              >
                Back
              </Typography>
            </ButtonBase>
          )}
          <Box
            sx={{
              maxWidth: '650px'
            }}
          >
            <LoginComponent
              emailButtonLabel='Next'
              loginFooter={<OnboardingFooter />}
              loginHeader={<OnboardingHeader />}
            />
          </Box>
        </Box>
      </Box>
    </OnboardingLayout>
  );
};

export default Onboarding;
